export default __webpack_public_path__ + "static/media/long-cases-icon.a00cdf3b.svg";